// Generated by Melange

import * as Stdlib__Option from "melange/option.js";

function prefer(previous, next) {
  if (next !== undefined) {
    return next;
  } else {
    return previous;
  }
}

function merge(previous, next) {
  return {
    id: next.id,
    title: prefer(previous.title, next.title),
    status: prefer(previous.status, next.status),
    input: prefer(previous.input, next.input),
    output: prefer(previous.output, next.output)
  };
}

function active(call) {
  const match = call.status;
  if (match === undefined) {
    return false;
  }
  switch (match) {
    case /* Completed */ 2 :
    case /* Failed */ 3 :
      return false;
    default:
      return true;
  }
}

function title(call) {
  return Stdlib__Option.value(call.title, "Tool call");
}

function status_text(call) {
  const match = call.status;
  if (match === undefined) {
    return "Status unavailable";
  }
  switch (match) {
    case /* Pending */ 0 :
      return "Pending";
    case /* In_progress */ 1 :
      return "In progress";
    case /* Completed */ 2 :
      return "Completed";
    case /* Failed */ 3 :
      return "Failed";
    case /* Unknown */ 4 :
      return "Status unavailable";
  }
}

export {
  merge,
  active,
  title,
  status_text,
}
/* No side effect */
